module.exports = __webpack_public_path__ + "static/img/m1_t1.e76f0017.jpg";